import React from "react";
import PageShell, { Reveal, SectionHeading, Tags } from "../components/PageShell";
import { experience, certifications, publication } from "../data/profile";
import "../styles/Experience.scss";

function Experience() {
  return (
    <PageShell slug="experience">
      <section>
        <SectionHeading eyebrow="Professional" title="Where I've worked" />
        <ol className="timeline">
          {experience.map((exp, i) => (
            <Reveal as="li" key={exp.company} className="timeline-item" delay={i * 0.08}>
              <div className="timeline-side">
                <span className="timeline-period">{exp.period}</span>
                <span className="timeline-location">{exp.location}</span>
                {exp.current && (
                  <span className="badge">
                    <span className="pulse" /> Current
                  </span>
                )}
              </div>
              <div className="timeline-dot" aria-hidden="true" />
              <div className="card timeline-card">
                <h3>{exp.role}</h3>
                <p className="timeline-company">{exp.company}</p>
                <ul className="bullets">
                  {exp.points.map((p) => (
                    <li key={p}>{p}</li>
                  ))}
                </ul>
                <Tags items={exp.stack} />
              </div>
            </Reveal>
          ))}
        </ol>
      </section>

      <section>
        <SectionHeading eyebrow="Recognition" title="Certifications & publication" />
        <div className="grid-2 recog-grid">
          <Reveal className="card publication-card">
            <span className="eyebrow">Publication · {publication.year}</span>
            <h3>{publication.title}</h3>
            <p className="pub-venue">{publication.venue}</p>
            <p>{publication.note}</p>
            <a className="text-link" href={publication.url} target="_blank" rel="noopener noreferrer">
              DOI {publication.doi} ↗
            </a>
          </Reveal>
          <div className="cert-list">
            {certifications.map((c, i) => (
              <Reveal key={c.title} className="card cert-row" delay={i * 0.06}>
                <div>
                  <h4>{c.title}</h4>
                  <span>{c.issuer}</span>
                </div>
                <span className="cert-date">{c.date}</span>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </PageShell>
  );
}

export default Experience;
